/**
 * document.title 设置
 */
export default {
  beforeCreate () {
    if (this.$options.title) {
      // 判断组件内是否存在computed对象
      if (typeof this.$options.computed === 'undefined') {
        this.$options.computed = {}
      }
      // 为组件添加computed对象并返回title值，用于动态更新title
      this.$options.computed.$_page_title = typeof this.$options.title === 'function' ? this.$options.title : () => this.$options.title
    }
  },
  created () {
    updateTitle(this)
  },
  mounted () {
    // dom 挂载之后 继续监听 meta 信息。如果发生变化，继续更新
    if (this.$options.title) {
      this.$watch('$_page_title', (val) => {
        document.title = val
      })
    }
  },
  activated () {
    updateTitle(this)
  }
}

function updateTitle (vm) {
  if (vm.$options.title) {
    document.title = vm.$_page_title
  }
}



// WEBPACK FOOTER //
// ./src/utils/title-mixin.js